import React from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';
import radii from '../../../styles/theme/foundation/radii';
import IconButtonMenu from '../../IconButtonMenu';

export const buttonBaseStyle = {
  background: 'inherit',
  borderBottom: '1px solid',
  borderBottomColor: colors.greyScale['200'],
  color: colors.greyScale['900'],
  cursor: 'pointer',
  minHeight: '68px',
  height: 'auto',
  padding: '1rem',
  width: 'inherit',
  _hover: { color: colors.primaryScale['600'], background: 'white' }
};

const TabButton = ({
  dataAnalyticsId, cypressId, idx, title, description, leftIcon, isActive, onClick, subMenu, id, collapsed, children
}) => {
  const buttonStyles = isActive
    ? ({
      ...buttonBaseStyle,
      background: 'rgba(0, 140, 255, 0.1)',
      borderRight: '2px solid',
      borderRightColor: colors.primaryScale['600'],
      color: colors.primaryScale['600'],
      borderRadius: idx === 0 ? `${radii.md} ${radii.md} 0px 0px` : '0px'
    })
    : { ...buttonBaseStyle, borderRadius: idx === 0 ? `${radii.md} ${radii.md} 0px 0px` : '0px' };

  return (
    <Flex
      _hover={{ color: colors.primaryScale['600'] }}
      alignItems={collapsed ? 'center' : 'flex-start'}
      data-analytics-id={dataAnalyticsId}
      data-cy={cypressId}
      display="flex"
      dusk={`${dataAnalyticsId}-btn`}
      justifyContent={collapsed ? 'center' : 'flex-start'}
      style={buttonStyles}
      onClick={onClick}
    >
      <Flex alignItems="center">
        {leftIcon && (
          <Tooltip aria-label={title} isDisabled={!collapsed} label={title} openDelay={300} placement="right">
            <span>
              <Icon
                as={leftIcon}
                boxSize="20px"
                color={isActive ? colors.primaryScale['600'] : colors.greyScale['400']}
                mr={collapsed ? 0 : '14px'}
              />
            </span>
          </Tooltip>
        )}
        {!collapsed && (
          <Flex
            direction="column"
            lineHeight="20px"
            textAlign="left"
          >
            <Box overflowWrap="anywhere" textStyle="bodyMd500" whiteSpace="nowrap">
              {title}
            </Box>
            {description && (
              <Text color={isActive ? colors.primaryScale['600'] : colors.greyScale['400']} fontSize="13px">
                {description}
              </Text>
            )}
            {children}
          </Flex>
        )}
      </Flex>
      {subMenu && (
      <IconButtonMenu
        cypressId={cypressId ? `${cypressId}-menu` : undefined}
        iconElement={<Icon as={BsThreeDots} width="20px" />}
        id={id}
        menuOptions={subMenu}
        size="xs"
        variant={isActive ? 'textPrimary' : 'textGrey'}
        width="auto"
      />
      )}
    </Flex>
  );
};

TabButton.propTypes = {
  collapsed: PropTypes.bool,
  idx: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  leftIcon: PropTypes.func,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  dataAnalyticsId: PropTypes.string,
  cypressId: PropTypes.string,
  children: PropTypes.elementType
};

export default TabButton;
